@for (requirement of task.ItemRequirementStatuses; track requirement) {
    <div class="required-item">
        <app-item-card
            [item]="requirement.AsItem"
            [quantity]="requirement.RequiredCount"
            [isQuestContext]="true"
            class="item-holder"></app-item-card>
    </div>
}
